import { defineStore } from "pinia";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { loginApi } from "@/api/user";
import router from "@/router"; // 导入路由实例
import { ElMessage } from "element-plus";

export const useUserStore = defineStore("user", {
  state: () => ({
    token: getToken(), // 从缓存获取 token
    userInfo: {},
    courseSessionId: null, // 课程会话ID
    // 学练一体页面状态
    learnTrainState: {
      curIndex: 0, // 当前题目索引
      activeStep: 0, // 当前步骤
      wordList: [], // 单词列表
      allWordList: [], // 所有单词列表
      currentUnitId: '', // 当前单元ID
      hasIndex: null,
      hasCorrect: null,
      status: false,
      totalScore: 0,
      recordedBlob: null,
      hintCount: 0,
      showPhonetic: false,
      showWord: false,
      reinforcementCount: 0,
    },
  }),
  // 开启持久化
  persist: {
    // 存储方式：localStorage、sessionStorage或cookies
    storage: localStorage,
    // 指定需要持久化的字段（默认全部持久化）
    // paths: ["token", "userInfo"],
    // 自定义存储的key
    key: "user_storage",
  },
  actions: {
    // 获取用户信息（包含角色）
    async getInfo(info) {
      this.token = info.token;
      this.userInfo = info.userInfo;
      console.log("info=====", info);
    },
    // 设置课程会话ID
    setCourseSessionId(courseSessionId) {
      this.courseSessionId = courseSessionId;
    },
    // 保存学练一体状态
    saveLearnTrainState(state) {
      this.learnTrainState = {
        ...this.learnTrainState,
        ...state,
        // 不保存 recordedBlob，因为 Blob 对象无法序列化
        recordedBlob: null,
      };
    },
    // 获取学练一体状态
    getLearnTrainState() {
      return this.learnTrainState;
    },
    // 清除学练一体状态
    clearLearnTrainState() {
      this.learnTrainState = {
        curIndex: 0,
        activeStep: 0,
        wordList: [],
        allWordList: [],
        currentUnitId: '',
        hasIndex: null,
        hasCorrect: null,
        status: false,
        totalScore: 0,
        recordedBlob: null,
        hintCount: 0,
        showPhonetic: false,
        showWord: false,
        reinforcementCount: 0,
      };
    },
    // 退出登录
    async logout() {
      removeToken(); // 清除缓存 token
      this.token = "";
      this.userInfo = {};
      this.courseSessionId = null; // 清除课程会话ID
      this.clearLearnTrainState(); // 清除学练一体状态
      // 重置路由
      router.push("/login");
      this.$reset() // 重置状态(会自动同步到存储)
      ElMessage.success("已退出");
    },
  },
});
